import {Box, Paper, Typography} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {useDraggable} from "@dnd-kit/core";
import {DraggableElementType} from "./EditSidebar";

export interface AddPanelDragData {
    type: DraggableElementType;
    icon: React.ReactNode;
    label: string;
    description: string;
}

interface Props {
    type: DraggableElementType;
    icon: React.ReactNode;
    label: string;
    description: string;
    isPreview?: boolean;
}

// dnd element for tables or elements on desktop (it's larger and has a description, also shows dragging state)
const PreviewDropTableElementDesktop: React.FC<Props> = ({
                                                             type,
                                                             icon,
                                                             label,
                                                             description,
                                                             isPreview = false,
                                                         }) => {
    const {attributes, listeners, setNodeRef, isDragging} = useDraggable({
        id: type,
        data: {type, icon, label, description} as AddPanelDragData,
        disabled: isPreview,
    });

    return (
        <Paper
            ref={isPreview ? undefined : setNodeRef}
            variant={isPreview ? "elevation" : "outlined"}
            elevation={isPreview ? 8 : 0}
            {...(isPreview ? {} : {...attributes, ...listeners})}
            sx={{
                p: 1.5,
                cursor: isPreview ? 'grabbing' : (isDragging ? 'grabbing' : 'grab'),
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                opacity: isDragging ? 0.5 : 1,
                transition: 'opacity 0.15s',
                touchAction: isPreview ? undefined : 'none',
                bgcolor: 'background.paper',
                ...(!isPreview && {
                    '&:hover': {
                        bgcolor: 'action.hover',
                        borderColor: 'primary.main',
                    },
                }),
            }}
        >
            <Box sx={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'grey.100',
                borderRadius: 1,
                color: 'text.secondary',
            }}>
                {icon}
            </Box>
            <Box sx={{flex: 1, minWidth: 0}}>
                <Typography fontWeight={500} noWrap>
                    {label}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                    {description}
                </Typography>
            </Box>

            <Box sx={{display: 'flex', alignItems: 'center'}}>
                <DragIndicatorIcon/>
            </Box>
        </Paper>
    );
};

export default PreviewDropTableElementDesktop;
